import React from 'react';
import { Modal } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/pro-regular-svg-icons';
import styles from './PopupConfirm.module.scss';

const WARNING_ICON = (
  <FontAwesomeIcon className={styles.icon} icon={faExclamationCircle} />
);

export const PopupConfirm = ({
  children,
  cancelText,
  icon = WARNING_ICON,
  open,
  title,
  okText,
  onOk,
  onCancel,
}) => {
  return (
    <Modal
      centered
      cancelText={cancelText}
      className={styles.modal}
      okText={okText}
      title={
        <header className={styles.header}>
          {icon}
          {title}
        </header>
      }
      visible={open}
      width={600}
      onCancel={onCancel}
      onOk={onOk}
    >
      {children}
    </Modal>
  );
};
